<template>
  <div id="modifylication">
    <!-- 申請表內容 -->
    <div
      id="Application_text"
      class="container"
    >
      <div class="row white-color word-bold">
        <!-- 標題 -->
        <div class="col-4 frame5" />
        <div class="col-5 frame6">
          多元繳費系統 -
          <span v-if="type === 'change'">變更收費項目申請表</span>
          <span v-else-if="type === 'Review'">審核收費項目申請表</span>
          <span v-else>變更收費項目申請表</span>
        </div>
        <div class="col-3 frame4" />
        <br>
        <!-- 公開收費項目 -->
        <div class="test frame2 pt-2">
          <span class="ml-3">是否為公開收費項目</span>
        </div>
        <div class="tests frame3 pt-1">
          <div class="form-check form-check-inline ml-2">
            <input
              id="FeeItemType1"
              class="form-check-input"
              type="radio"
              value="1"
              v-model.number="ReadyModify.FeeItemType"
              :disabled="type === 'Print'"
            >
              <label
                class="form-check-label"
                for="FeeItemType1"
              >
                是
              </label>
          </div>
          <div class="form-check form-check-inline mt-1">
            <input
              id="FeeItemType2"
              class="form-check-input"
              type="radio"
              value="2"
              v-model.number="ReadyModify.FeeItemType"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label"
              for="FeeItemType2"
            >
              否
            </label>
          </div>
        </div>
        <!-- 申請單位 -->
        <div class="col-2 frame7 pt-2">
          申請單位
        </div>
        <div class="col-4 frame3 pt-2">
          <span class="ml-2">
            {{ NewDeptId.DeptName }}
          </span>
        </div>
        <!-- 收費項目名稱 -->
        <div class="test frame2 pt-1">
          <span class="ml-3">收費項目名稱</span>
        </div>
        <div class="tests frame3">
          <input
            class="form-control"
            type="text"
            v-model="ReadyModify.FeeItemName"
            :disabled="type === 'Print'"
          >
        </div>
        <!-- 收費項目編號 -->
        <div class="col-2 frame7 pt-1">
          收費項目編號
        </div>
        <div class="col-4 frame3">
          <input
            class="form-control"
            type="text"
            v-model="fee"
            disabled
          >
        </div>
        <!-- 變更原因，只有變更才顯示此欄位 -->
        <div class="col-2 frame2 pt-1" v-if="type === 'change'">
          變更原因
        </div>
        <div class="col-10 frame8" v-if="type === 'change'">
          <input
            class="form-control"
            v-model="ReadyModify.ModifyReason"
          >
        </div>
        <!-- 繳款金額 -->
        <div class="col-2 frame2 pt-1">
          繳款金額
        </div>
        <div class="col-10 frame8">
          <div class="form-check form-check-inline ml-2">
            <input
              id="FeeValueType1"
              class="form-check-input"
              type="radio"
              value="1"
              v-model.number="ReadyModify.FeeValueType"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label"
              for="FeeValueType1"
            >
              固定金額
            </label>
              <input
                class="ra-input ml-2 mr-2"
                type="text"
                style="width: 150px;"
                @change="CheckNum"
                v-model.number="ReadyModify.FeeItemValue"
                :disabled="type === 'Print'"
              >
              元
          </div>
          <div class="form-check form-check-inline mt-2 mb-2">
            <input
              id="FeeValueType2"
              class="form-check-input"
              type="radio"
              value="2"
              v-model.number="ReadyModify.FeeValueType"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label"
              for="FeeValueType2"
            >
              非固定金額(由串接系統產生或上傳繳費資料)
            </label>
          </div>
        </div>
        <!-- 申請期限 -->
        <div class="col-2 frame2 pt-1">
          申請期限
        </div>
        <div class="col-10 frame8">
          <div class="form-check form-check-inline ml-2">
            <input
              id="PayDeadline1"
              class="form-check-input"
              type="radio"
              v-model.number="ReadyModify.PayDeadline"
              value="1"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label"
              for="PayDeadline1"
            >
              繳費期限
              起始日
              <a-locale-provider :locale="zhTW">
                <a-date-picker
                  size="large"
                  @change="onChange"
                  :format="dateFormat"
                  v-model="datePayDateBegin"
                  :disabled="type === 'Print'"
                />
              </a-locale-provider>
              截止日
              <a-locale-provider :locale="zhTW">
                <a-date-picker
                  size="large"
                  @change="onChanges"
                  :format="dateFormat"
                  v-model="datePayDateEnd"
                  :disabled="type === 'Print'"
                />
              </a-locale-provider>
            </label>
          </div>
          <div class="form-check form-check-inline mt-2 mb-2">
            <input
              id="PayDeadline2"
              class="form-check-input ml-2 mr-2"
              type="radio"
              value="2"
              v-model.number="ReadyModify.PayDeadline"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label"
              for="PayDeadline2"
            >
              無(長期、持續性收款)
            </label>
          </div>
        </div>
        <!-- 申請版面-繳費通路 -->
        <div class="col-2 frame2 pt-1">
          繳費通路(複選)
        </div>
        <div class="col-10 frame8">
          <!-- 申請版面-國內信用卡 -->
          <div class="form-check form-check-inline ml-2 mt-2 dblock">
            1.
            <input
              id="ApplyBit0"
              class="form-check-input"
              type="checkbox"
              v-model="modifybit.bit0"
              :true-value="1"
              :false-value="0"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label"
              for="ApplyBit0"
            >
              政府機關繳費平台信用卡(手續費2~35元)
            </label>
          </div>
          <!-- 申請版面-國外信用卡 -->
          <div class="form-check form-check-inline ml-2 mt-2 dblock">
            2.
            <input
              id="ApplyBit1"
              class="form-check-input"
              type="checkbox"
              v-model="modifybit.bit1"
              :true-value="1"
              :false-value="0"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label"
              for="ApplyBit1"
            >
              可收全部信用卡、國外卡、銀聯卡(手續費2%)
            </label>
            <v-font
              font-css="small-color"
              font-text="*洽談中，暫停開放"
            />
          </div>
          <div class="form-check form-check-inline ml-4">
            手續費(必填)由：
            <input
              id="CardRadio1"
              class="form-check-input"
              type="radio"
              v-model="Card.Radio"
              value="本計畫"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label mr-2"
              for="CardRadio1"
            >
              本計畫
            </label>
            <input
              class="ra-input"
              type="text"
              style="width: 220px;"
              v-model="Card.Input0"
              :disabled="type === 'Print'"
            >
            <label class="form-check-label ml-2 mr-2">
              費
            </label>
            <input
              id="CardRadio2"
              class="form-check-input"
              type="radio"
              v-model="Card.Radio"
              value="本單位"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label mr-2"
              for="CardRadio2"
            >
              本單位
            </label>
            <input
              class="ra-input"
              type="text"
              style="width: 220px;"
              v-model="Card.Input1"
              :disabled="type === 'Print'"
            >
            <label class="form-check-label ml-2 mr-2">
              費
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              id="CardRadio3"
              class="form-check-input ml-4"
              type="radio"
              v-model="Card.Radio"
              value="其他計畫"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label mr-2"
              for="CardRadio3"
            >
              其他計畫
            </label>
            <input
              class="ra-input mt-1"
              type="text"
              style="width: 220px;"
              v-model="Card.Input2"
              :disabled="type === 'Print'"
            >
            <label class="form-check-label ml-2">
              項下支付
            </label>
          </div>
          <!-- 申請版面-一卡通 -->
          <div class="form-check form-check-inline ml-2 mt-2 dblock">
            3.
            <input
              id="ApplyBit2"
              class="form-check-input"
              type="checkbox"
              v-model="modifybit.bit2"
              :true-value="1"
              :false-value="0"
              :disabled="type === 'Print'"
              checked
            >
            <label
              class="form-check-label"
              for="ApplyBit2"
            >
              一卡通(手續費目前 0 元)，此項目為繳費機功能為「必選項目」
            </label>
          </div>
          <div class="form-check form-check-inline ml-4">
            手續費(必填)由：
            <input
              id="iPASSRadio1"
              class="form-check-input"
              type="radio"
              v-model="iPASS.Radio"
              value="本計畫"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label mr-2"
              for="iPASSRadio1"
            >
              本計畫
            </label>
            <input
              class="ra-input"
              type="text"
              style="width: 220px;"
              v-model="iPASS.Input0"
              :disabled="type === 'Print'"
            >
            <label class="form-check-label ml-2 mr-2">
              費
            </label>
            <input
              id="iPASSRadio2"
              class="form-check-input"
              type="radio"
              v-model="iPASS.Radio"
              value="本單位"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label mr-2"
              for="iPASSRadio2"
            >
              本單位
            </label>
            <input
              class="ra-input"
              type="text"
              style="width: 220px;"
              v-model="iPASS.Input1"
              :disabled="type === 'Print'"
            >
            <label class="form-check-label ml-2 mr-2">
              費
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              id="iPASSRadio3"
              class="form-check-input ml-4"
              type="radio"
              v-model="iPASS.Radio"
              value="其他計畫"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label mr-2"
              for="iPASSRadio3"
            >
              其他計畫
            </label>
            <input
              class="ra-input mt-1"
              type="text"
              style="width: 220px;"
              v-model="iPASS.Input2"
              :disabled="type === 'Print'"
            >
            <label class="form-check-label ml-2">
              項下支付
            </label>
          </div>
          <!-- 申請版面-LINE Pay -->
          <div class="form-check form-check-inline ml-2 mt-2 dblock">
            4.
            <input
              id="ApplyBit3"
              class="form-check-input"
              type="checkbox"
              v-model="modifybit.bit3"
              :true-value="1"
              :false-value="0"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label"
              for="ApplyBit3"
            >
              LINE PAY (手續費綁帳戶者1.26%、綁信用卡者1.89%)
            </label>
          </div>
          <div class="form-check form-check-inline ml-4">
            手續費(必填)由：
            <input
              id="LineRadio1"
              class="form-check-input"
              type="radio"
              v-model="Line.Radio"
              value="本計畫"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label mr-2"
              for="LineRadio1"
            >
              本計畫
            </label>
            <input
              class="ra-input"
              type="text"
              style="width: 220px;"
              v-model="Line.Input0"
              :disabled="type === 'Print'"
            >
            <label class="form-check-label ml-2 mr-2">
              費
            </label>
            <input
              id="LineRadio2"
              class="form-check-input"
              type="radio"
              v-model="Line.Radio"
              value="本單位"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label mr-2"
              for="LineRadio2"
            >
              本單位
            </label>
            <input
              class="ra-input"
              type="text"
              style="width: 220px;"
              v-model="Line.Input1"
              :disabled="type === 'Print'"
            >
            <label class="form-check-label ml-2 mr-2">
              費
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              id="LineRadio3"
              class="form-check-input ml-4"
              type="radio"
              v-model="Line.Radio"
              value="其他計畫"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label mr-2"
              for="LineRadio3"
            >
              其他計畫
            </label>
            <input
              class="ra-input mt-1"
              type="text"
              style="width: 220px;"
              v-model="Line.Input2"
              :disabled="type === 'Print'"
            >
            <label class="form-check-label ml-2">
              項下支付
            </label>
          </div>
          <!-- 申請版面-超商繳費單 -->
          <div class="form-check form-check-inline ml-2 mt-2 dblock">
            5.
            <input
              id="ApplyBit4"
              class="form-check-input"
              type="checkbox"
              v-model="modifybit.bit4"
              :true-value="1"
              :false-value="0"
              :disabled="type === 'Print'"
              @click="Checkbit4bit5('bit4')"
            >
            <label
              class="form-check-label"
              for="ApplyBit4"
            >
              四大超商繳費單(含銀行、ATM)
            </label>
            <v-font
              font-css="small-color"
              font-text="(包含臨櫃( 土銀)繳費單、WebATM、實體ATM)"
            />
          </div>
          <!-- 申請版面-WebATM -->
          <div class="form-check form-check-inline ml-2 mt-2 mb-2 dblock">
            6.
            <input
              id="ApplyBit5"
              class="form-check-input"
              type="checkbox"
              v-model="modifybit.bit5"
              :true-value="1"
              :false-value="0"
              :disabled="type === 'Print'"
              @click="Checkbit4bit5('bit5')"
            >
            <label
              class="form-check-label"
              for="ApplyBit5"
            >
              臨櫃( 土銀)繳費單、WebATM、實體ATM
            </label>
            <v-font
              font-css="small-color"
              font-text="(不含四大超商繳費)"
            />
          </div>
        </div>
        <!-- End col-10 -->
        <!-- 申請版面-串接系統 -->
        <div class="col-2 frame2 pt-1">
          是否為串接系統
        </div>
        <div class="col-10 frame8">
          <div class="form-check form-check-inline ml-2">
            <input
              id="IsIntegrated"
              class="form-check-input"
              type="radio"
              v-model.number="ReadyModify.IsIntegrated"
              value="1"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label mr-2"
              for="IsIntegrated"
            >
              是，系統名稱
            </label>
            <select
              class="input-style"
              v-model="ReadyModify.IntegratedSysId"
              :disabled="type === 'Print'"
            >
              <option
                v-for="Sysids in Sysid"
                :key="Sysids.id"
                :value="Sysids.IntegratedSysId"
              >
                {{ Sysids.SysName }}
              </option>
            </select>
          </div>
          <div class="form-check form-check-inline mt-2 mb-2">
            <input
              id="IsIntegrated2"
              class="form-check-input"
              type="radio"
              v-model.number="ReadyModify.IsIntegrated"
              value="0"
              :disabled="type === 'Print'"
            >
            <label
              class="form-check-label"
              for="IsIntegrated2"
            >
              否
            </label>
          </div>
        </div>
        <!-- 共同版面-核章 -->
        <div class="col-12 frame text-size textalign">
          業務單位
        </div>
        <div class="col-6 frame2 textalign">
          單位管理人核章
        </div>
        <div class="col-6 frame3 textalign">
          單位主管核章
        </div>
        <div class="col-6 frame2">
          <br>
          <br>
          <br>
          <br>
        </div>
        <div class="col-6 frame3" />
        <div class="col-12 frame2 textalign">
          主計室
        </div>
        <div class="col-3 frame2 textalign">
          會計資料
        </div>
        <div class="col-3 frame3 textalign">
          承辦人核章
        </div>
        <div class="col-3 frame3 textalign">
          組長核章
        </div>
        <div class="col-3 frame3 textalign">
          主計主任核章
        </div>
        <!--會計資料 -->
        <div class="col-3 frame10">
          <div class="row">
            <label
              class="mt-2 ml-2"
              for="AccountingTitle"
            >
              會計科目：
            </label>
            <input
              id="AccountingTitle"
              class="form-control mr-2 ml-2"
              type="text"
              v-model="ReadyModify.AccountingTitle"
              :disabled="type === 'Print'"
            >
          </div>
          <div class="row">
            <label
              class="mt-2 ml-2"
              for="ProjectNumber"
            >
              計畫編號：
            </label>
            <input
              id="ProjectNumber"
              class="form-control mr-2 ml-2 mb-2"
              type="text"
              v-model="ReadyModify.ProjectNumber"
              :disabled="type === 'Print'"
            >
          </div>
        </div>
        <div class="col-3 frame8" />
        <div class="col-3 frame8" />
        <div class="col-3 frame8" />
        <div class="col-12 frame2 textalign">
          總務處
        </div>
        <div class="col-3 frame2 textalign">
          承辦人核章
        </div>
        <div class="col-3 frame3 textalign">
          出納組長核章
        </div>
        <div class="col-3 frame3 textalign">
          總務長核章
        </div>
        <div class="col-3 frame3 textalign">
          校長核章
        </div>
        <div class="col-3 frame2">
          <br>
          <br>
          <br>
          <br>
          <br>
        </div>
        <div class="col-3 frame3" />
        <div class="col-3 frame3" />
        <div class="col-3 frame3" />
      </div><!-- End row -->
      <br>
    </div>
    <!-- 功能鈕 -->
    <div class="pb-4 no-print">
      <v-button
        v-if="type === 'change' && changeprint === false"
        btn-text="申請變更"
        title="申請變更收費項目申請表"
        btnType="primary"
        @click.native="PostFeeitemModify(3)"
      />
      <v-button
        v-if="type === 'Review'"
        class="ml-2"
        btn-text="審核通過"
        title="收費項目申請-審核通過"
        btnType="primary"
        @click.native="PostFeeitemModify(1)"
      />
      <v-button
        v-if="type === 'change' && changeprint === true"
        class="ml-2"
        btn-text="列印申請表"
        title="列印收費項目申請表"
        btnType="warning"
        @click.native="print"
      />
      <v-button
        v-if="type === 'Print'"
        class="ml-2"
        btn-text="列印申請表"
        title="列印收費項目申請表"
        btnType="warning"
        @click.native="print"
      />
      <a
        class="btn btn-secondary ml-2"
        href="/#/admin/payment/review"
        role="button"
      >
        回上一頁
      </a>
      <v-button
        v-if="type === 'Review'"
        class="ml-2"
        btn-text="審核不通過"
        title="收費項目申請-審核不通過"
        btnType="danger"
        @click.native="PostFeeitemModify(0)"
      />
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import moment from 'moment'
import { apiFeeitemModify, apiFeeitemEnable, apiFeeitemQuery, apiSysid } from '../../Api/api'
import 'ant-design-vue/lib/date-picker/style/css'
import zhTW from 'ant-design-vue/lib/locale-provider/zh_TW'
export default {
  props: {
    app: {
      type: String,
      default: ''
    },
    fee: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      Card: { // 繳費通路 信用卡 國內外 1. 2.選項
        Radio: '本計畫',
        Input0: '',
        Input1: '',
        Input2: ''
      },
      iPASS: { // 一卡通 3.選項
        Radio: '本計畫',
        Input0: '',
        Input1: '',
        Input2: ''
      },
      Line: { // LinePay 4.選項
        Radio: '本計畫',
        Input0: '',
        Input1: '',
        Input2: ''
      },
      ReadyModify: [],
      modifybit: {
        bit0: 0,
        bit1: 0,
        bit2: 0,
        bit3: 0,
        bit4: 0,
        bit5: 0,
        bit6: 0,
        bit7: 0
      },
      Sysid: [],
      NewDeptId: '',
      zhTW,
      dateFormat: 'YYYY/MM/DD',
      PayDateBegin: '',
      PayDateEnd: '',
      datePayDateBegin: undefined,
      datePayDateEnd: undefined,
      changeprint: false,
      prints: false // 列印預設
    }
  },
  created () {
    const vm = this
    vm.PostFeeitemQuery() // 查詢
    vm.PostSysid() // 異質
  },
  methods: {
    moment,
    print () { // 列印
      var text = document
      print(text)
    },
    onChange (date, dateString) { // 起
      this.datePayDateBegin = date
      this.ReadyModify.PayDateBegin = dateString
    },
    onChanges (date, dateString) { // 迄
      this.datePayDateEnd = date
      this.ReadyModify.PayDateEnd = dateString
    },
    PostFeeitemQuery () { // 查詢 B_API 008
      // 定義資料
      const vm = this
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      NewData.FeeItemId = vm.fee
      NewData.ApplyDeptId = vm.app
      NewData.DeptId = UserData.DeptId
      // 呼叫API
      apiFeeitemQuery(NewData).then(
        res => {
          if (res !== undefined) {
            vm.ReadyModify = res.Data[0]
            const DeptData = {}
            DeptData.DeptId = res.Data[0].ApplyDeptId
            DeptData.DeptName = res.Data[0].ApplyDeptName
            vm.NewDeptId = DeptData
            if (vm.ReadyModify.PayDeadline === 1) { // 繳費期限類型 true
              if (vm.ReadyModify.PayDateBegin === null) { // 起始日
                vm.datePayDateBegin = undefined
                vm.PayDateBegin = ''
              } else {
                vm.PayDateBegin = vm.ReadyModify.PayDateBegin
                vm.datePayDateBegin = moment(vm.ReadyModify.PayDateBegin, vm.dateFormat)
              }
              if (vm.ReadyModify.PayDateEnd === null) { // 截止日
                vm.datePayDateEnd = undefined
                vm.PayDateEnd = ''
              } else {
                vm.datePayDateEnd = moment(vm.ReadyModify.PayDateEnd, vm.dateFormat)
                vm.PayDateEnd = vm.ReadyModify.PayDateEnd
              }
            }
            vm.editselect()
          } else {
            $('#CheckError').modal('show')
            vm.$router.push({ name: 'Admin_Payment_review' }) // 導向
          }
        }
      )
    },
    PostSysid () { // 異質系統代碼對照表 P_API002
      // 定義資料
      const vm = this
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      NewData.IntegratedSysId = '255'
      NewData.Token = '9C2D3D654D8E495DBA5E38A0F8E20A32'
      // 呼叫API
      apiSysid(NewData).then(
        res => {
          if (res !== undefined) {
            vm.Sysid = res.Data
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    PostFeeitemModify (data) { // 變更B_API 009 or 審核B_API 010
      // 定義資料
      var NewModifyData
      const vm = this
      const NewData = vm.ReadyModify
      // 清除多餘資訊
      delete NewData.ApplyDeptId
      delete NewData.ApplyDT
      delete NewData.ApplyDeptName
      delete NewData.ApplyStaffId
      delete NewData.ApplyStaffName
      delete NewData.PayDatePeriod
      // 繳費通路種類-組合繳費通路選項，並刪除','
      const modifybyte = vm.modifybit.bit7 + ',' + vm.modifybit.bit6 + ',' +
        vm.modifybit.bit5 + ',' + vm.modifybit.bit4 + ',' +
        vm.modifybit.bit3 + ',' + vm.modifybit.bit2 + ',' +
        vm.modifybit.bit1 + ',' + vm.modifybit.bit0
      const Modifybyte = modifybyte.replace(/,/g, '')
      NewData.PayCategory = parseInt(Modifybyte, 2)
      // 判斷繳費期限
      // 繳費期限日期，若無期限則填入0
      if (NewData.PayDeadline === 2) {
        NewData.PayDateBegin = ''
        NewData.PayDateEnd = ''
      }
      // 繳費通路次項目整合
      var ErrorTest = ''
      if (NewData.FeeItemType === 0) {
        ErrorTest = '請選擇公開收費項目。'
      }
      if (NewData.FeeItemName === '') {
        ErrorTest = '請填寫收費項目名稱。'
      }
      if (NewData.FeeValueType === 0) {
        ErrorTest = '請選擇繳款金額。'
      } else if (NewData.FeeValueType === 1) {
        if (NewData.FeeItemValue <= 0) {
          ErrorTest = '請填寫固定金額。'
        }
      }
      if (NewData.FeeValueType === 2) {
        NewData.FeeItemValue = 0
      }
      if (NewData.PayDeadline === 0) {
        ErrorTest = '請選擇繳費期限類型。'
      } else if (NewData.PayDeadline === 1) {
        if (NewData.PayDateBegin === '') {
          ErrorTest = '請選擇繳費起始日。'
        }
        if (NewData.PayDateEnd === '') {
          ErrorTest = '請選擇繳費截止日。'
        }
      } else {
        if (NewData.PayDeadline === 2) {
          NewData.PayDatePeriod = 0
        }
      }
      var CText
      const CR = vm.Card.Radio
      if (vm.modifybit.bit0 === 0 && vm.modifybit.bit1 === 0) {
        NewData.CreditChargeSrc = ''
      } else {
        if (CR === '') {
          ErrorTest = '請選擇繳費通路(2)的次項目。'
        }
        if (CR === '本計畫') {
          if (vm.Card.Input0 === '' || vm.Card.Input0 === undefined) {
            CText = ''
          } else {
            CText = vm.Card.Input0
          }
        } else if (CR === '本單位') {
          if (vm.Card.Input1 === '') {
            ErrorTest = '請填寫繳費通路(2)本單位。'
          } else {
            CText = vm.Card.Input1
          }
        } else if (CR === '其他計畫') {
          if (vm.Card.Input2 === '') {
            ErrorTest = '請填寫繳費通路(2)其他計畫。'
          } else {
            CText = vm.Card.Input2
          }
        }
        NewData.CreditChargeSrc = CR + ',' + CText
      }
      var iText
      const iR = vm.iPASS.Radio
      if (vm.modifybit.bit2 === 1) {
        if (iR === '') {
          ErrorTest = '請選擇繳費通路(3)的次項目。'
        }
        if (iR === '本計畫') {
          if (vm.iPASS.Input0 === '' || vm.iPASS.Input0 === undefined) {
            iText = ''
          } else {
            iText = vm.iPASS.Input0
          }
        } else if (iR === '本單位') {
          if (vm.iPASS.Input1 === '') {
            ErrorTest = '請填寫繳費通路(3)本單位。'
          } else {
            iText = vm.iPASS.Input1
          }
        } else if (iR === '其他計畫') {
          if (vm.iPASS.Input2 === '') {
            ErrorTest = '請填寫繳費通路(3)其他計畫。'
          } else {
            iText = vm.iPASS.Input2
          }
        }
        NewData.MifareChargeSrc = iR + ',' + iText
      } else {
        ErrorTest = '繳費通路(3)為必填項目。'
      }
      var LText
      const LR = vm.Line.Radio
      if (vm.modifybit.bit3 === 1) {
        if (LR === '') {
          ErrorTest = '請選擇繳費通路(4)的次項目。'
        }
        if (LR === '本計畫') {
          if (vm.Line.Input0 === '' || vm.Line.Input0 === undefined) {
            LText = ''
          } else {
            LText = vm.Line.Input0
          }
        } else if (LR === '本單位') {
          if (vm.Line.Input1 === '') {
            ErrorTest = '請填寫繳費通路(4)本單位。'
          } else {
            LText = vm.Line.Input1
          }
        } else if (LR === '其他計畫') {
          if (vm.Line.Input2 === '') {
            ErrorTest = '請填寫繳費通路(4)其他計畫。'
          } else {
            LText = vm.Line.Input2
          }
        }
        NewData.LINEChargeSrc = LR + ',' + LText
      }
      if (NewData.IsIntegrated === 3) {
        ErrorTest = '請選擇是否為串接系統。'
      } else if (NewData.IsIntegrated === 1) {
        if (NewData.IntegratedSysId === '') {
          ErrorTest = '請選擇異質系統。'
        }
      }
      if (ErrorTest !== '') {
        vm.ErrorModal(ErrorTest)
        return false
      }
      // 判斷data 是變更 or 審核
      if (data === 3) {
        NewData.DeptId = vm.NewDeptId.DeptId // 取 NewDeptId -> 部門ID
        if (!vm.ReadyModify.ModifyReason || vm.ReadyModify.ModifyReason === '') {
          vm.ErrorModal('請填寫變更原因。')
          return false
        }
        vm.changeprint = true
        delete NewData.CurrentType
        NewModifyData = Object.assign(JSON.parse(sessionStorage.getItem('Identity')), NewData)
        // 呼叫API
        apiFeeitemModify(NewModifyData).then(
          res => {
            if (res !== undefined) {
              vm.$bus.$emit('Modals', '變更送出成功')
              $('#CheckOk').modal('show')
              // vm.$router.push({
              //   name: 'Admin_Payment_review'
              // })
            } else {
              $('#CheckError').modal('show')
            }
          }
        )
      } else {
        NewData.CurrentType = data
        NewModifyData = Object.assign(JSON.parse(sessionStorage.getItem('Identity')), NewData)
        const ReviewText = (data === 1) ? '審核通過' : '審核不通過'
        apiFeeitemEnable(NewModifyData).then(
          res => {
            if (res !== undefined) {
              vm.$bus.$emit('Modals', ReviewText)
              $('#CheckOk').modal('show')
              vm.$router.push({
                name: 'Admin_Payment_review'
              })
            } else {
              $('#CheckError').modal('show')
            }
          }
        )
      }
    },
    editselect () { // 分割繳費方式
      const vm = this
      let p = null
      let a1 = null
      let b1 = null
      let num2 = null
      const num1 = vm.ReadyModify.PayCategory
      const currnum = 128
      // num1 二進位轉換
      if (num1 >= currnum) {
        num2 = '1'; a1 = num1 - currnum; b1 = currnum / 2
      } else {
        num2 = '0'; a1 = num1; b1 = currnum / 2
      }
      for (p = 1; p <= 7; p++) {
        if (a1 >= b1) {
          num2 = num2 + '1'; a1 = a1 - b1; b1 = b1 / 2
        } else {
          num2 = num2 + '0'; b1 = b1 / 2
        }
      }
      // 切割num2字串
      vm.modifybit.bit7 = parseInt(num2.slice(0, 1))
      vm.modifybit.bit6 = parseInt(num2.slice(1, 2))
      vm.modifybit.bit5 = parseInt(num2.slice(2, 3))
      vm.modifybit.bit4 = parseInt(num2.slice(3, 4))
      vm.modifybit.bit3 = parseInt(num2.slice(4, 5))
      vm.modifybit.bit2 = parseInt(num2.slice(5, 6))
      vm.modifybit.bit1 = parseInt(num2.slice(6, 7))
      vm.modifybit.bit0 = parseInt(num2.slice(7, 8))
      vm.editChargeSrc()
    },
    editChargeSrc () { // 分割 繳費方式 細項
      const vm = this
      if (vm.modifybit.bit0 === 1 || vm.modifybit.bit1 === 1) {
        const Credit = vm.ReadyModify.CreditChargeSrc
        const Creditdata = Credit.split(',')
        vm.Card.Radio = Creditdata[0]
        if (Creditdata[0] === '本計畫') {
          if (Creditdata[1] === 'undefined') {
            vm.Card.Input0 = ''
          } else {
            vm.Card.Input0 = Creditdata[1]
          }
        } else if (Creditdata[0] === '本單位') {
          vm.Card.Input1 = Creditdata[1]
        } else if (Creditdata[0] === '其他計畫') {
          vm.Card.Input2 = Creditdata[1]
        }
      }
      if (vm.modifybit.bit3 === 1) {
        const LINE = vm.ReadyModify.LINEChargeSrc
        const LINEdata = LINE.split(',')
        vm.Line.Radio = LINEdata[0]
        if (LINEdata[0] === '本計畫') {
          if (LINEdata[1] === 'undefined') {
            vm.Line.Input0 = ''
          } else {
            vm.Line.Input0 = LINEdata[1]
          }
        } else if (LINEdata[0] === '本單位') {
          vm.Line.Input1 = LINEdata[1]
        } else if (LINEdata[0] === '其他計畫') {
          vm.Line.Input2 = LINEdata[1]
        }
      }
      const Mifare = vm.ReadyModify.MifareChargeSrc
      const Mifaredata = Mifare.split(',')
      vm.iPASS.Radio = Mifaredata[0]
      if (Mifaredata[0] === '本計畫') {
        if (Mifaredata[1] === 'undefined') {
          vm.iPASS.Input0 = ''
        } else {
          vm.iPASS.Input0 = Mifaredata[1]
        }
      } else if (Mifaredata[0] === '本單位') {
        vm.iPASS.Input1 = Mifaredata[1]
      } else if (Mifaredata[0] === '其他計畫') {
        vm.iPASS.Input2 = Mifaredata[1]
      }
    },
    Checkbit4bit5 (data) { // 繳款項目4&5 判斷
      const vm = this
      if (data === 'bit4') {
        var el = document.getElementById('ApplyBit5')
        el.checked = false
        vm.modifybit.bit4 = 1
        vm.modifybit.bit5 = 0
      } else if (data === 'bit5') {
        var els = document.getElementById('ApplyBit4')
        els.checked = false
        vm.modifybit.bit4 = 0
        vm.modifybit.bit5 = 1
      }
    },
    CheckNum () { // 金額防呆
      const vm = this
      const Value = vm.ReadyModify.FeeItemValue
      if (typeof (Value) === 'number') {
        if (Value < 0) {
          vm.ErrorModal('金額不得小於0')
          vm.ReadyModify.FeeItemValue = 0
        }
      } else {
        vm.ErrorModal('固定金額請輸入數字')
        vm.ReadyModify.FeeItemValue = 0
      }
    },
    ErrorModal (data) {
      this.$bus.$emit('Modals', data)
      $('#CheckError').modal('show')
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/applicationform.scss';
.test {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 20%;
  flex: 0 0 20%;
  max-width: 20%;
}
.tests {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30%;
  flex: 0 0 30%;
  max-width: 30%;
}
</style>
